import { useId } from "react";

const TIP =
  "Credit materials the base model no longer consumes when this option is added.";

/** Divider and hover note for bill lines that save base-model materials. */
export function ManufacturingNegativeAdjustmentsHeading() {
  const tipId = useId();
  return (
    <div className="mt-3 flex items-center gap-2 border-t border-gray-200 pt-3 dark:border-zinc-700">
      <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-700 dark:text-zinc-200">
        Negative Adjustments
      </h3>
      <span className="group relative inline-flex">
        <button
          type="button"
          className="inline-flex h-5 w-5 items-center justify-center rounded-full border border-amber-300 bg-amber-50 text-[11px] font-bold leading-none text-amber-800 hover:bg-amber-100 focus:outline-none focus:ring-2 focus:ring-amber-400 dark:border-amber-700 dark:bg-amber-950/50 dark:text-amber-200"
          aria-describedby={tipId}
          aria-label="About negative adjustments"
        >
          !
        </button>
        <span
          id={tipId}
          role="tooltip"
          className="pointer-events-none absolute left-0 top-full z-20 mt-1 hidden w-64 rounded-md border border-gray-200 bg-white px-2 py-1.5 text-left text-[11px] font-normal normal-case tracking-normal text-gray-700 shadow-lg group-hover:block group-focus-within:block dark:border-zinc-600 dark:bg-zinc-900 dark:text-zinc-200"
        >
          {TIP}
        </span>
      </span>
    </div>
  );
}
